import { FamilyRestroomOutlined } from "@mui/icons-material";

const familyMemberResource = {
    title: "Family Members",
    singular: "Family Member",

    collectionField: "familyMembers",

    displayField: "lastName",
    icon: FamilyRestroomOutlined,

    columns: [
        {
            field: "relation",
            header: "Relation",
            type: "text"
        },
        {
            field: "firstName",
            header: "First Name",
            type: "text"
        },
        {
            field: "lastName",
            header: "Last Name",
            type: "text"
        },
        {
            field: "dateOfBirth",
            header: "Date of Birth",
            type: "date"
        },
        {
            field: "occupation",
            header: "Occupation",
            type: "text"
        }
    ],

    fields: {
        relation: {
            name: "relation",
            label: "Relation",
            type: "select",
            required: true,
            options: [
                { value: "Spouse", label: "Spouse" },
                { value: "Child", label: "Child" },
                { value: "Parent", label: "Parent" },
                { value: "Sibling", label: "Sibling" },
                { value: "Other", label: "Other" }
            ]
        },
        firstName: {
            name: "firstName",
            label: "First Name",
            type: "text",
            required: true
        },
        middleName: {
            name: "middleName",
            label: "Middle Name",
            type: "text",
            required: true
        },
        lastName: {
            name: "lastName",
            label: "Last Name",
            type: "text",
            required: true
        },
        suffix: {
            name: "suffix",
            label: "Suffix",
            type: "select",
            required: true,
            options: [
                { value: "", label: "None" },
                { value: "Jr.", label: "Jr." },
                { value: "Sr.", label: "Sr." },
                { value: "II", label: "II" },
                { value: "III", label: "III" },
                { value: "IV", label: "IV" }
            ]
        },
        dateOfBirth: {
            name: "dateOfBirth",
            label: "Date of Birth",
            type: "date",
            required: true
        },
        birthPlace: {
            name: "birthPlace",
            label: "Birth Place",
            type: "text"
        },
        occupation: {
            name: "occupation",
            label: "Occupation",
            type: "text"
        },
        employer: {
            name: "employer",
            label: "Employer",
            type: "text"
        },
        maidenName: {
            name: "maidenName",
            label: "Maiden Name",
            type: "text"
        },
        phoneNumber: {
            name: "phoneNumber",
            label: "Phone Number",
            type: "text"
        },
        phoneNumberExt: {
            name: "phoneNumberExt",
            label: "Phone Number Ext.",
            type: "text"
        },
        adress1: {
            name: "adress1",
            label: "Address 1",
            type: "text"
        },
        adress2: {
            name: "adress2",
            label: "Address 2",
            type: "text"
        },
        adress3: {
            name: "adress3",
            label: "Address 3",
            type: "text"
        }
    }
};

export default familyMemberResource;
